module.exports = __webpack_public_path__ + "img/turn-left.a92f5a97.svg";